import React from "react";
import Meta from "../components/global/meta";
import Four0Four from "../components/404";
import Loader from "../components/global/loader";
import BlogHeader from "../components/cms/blocks/blogHeader";
import BlogContent from "../components/cms/blocks/blogContent";

export default ({ content }) => {
  if (content === undefined) return <Loader withMargins />;
  if (content === null) return <Four0Four />;

  const { title, header, blogContent, meta, nextPost, publicationDate } = content;

  return (
    <div id="post">
      <Meta title={title} seo={meta?.seo} type="article" />
      {header ? <BlogHeader data={header} date={publicationDate} /> : null}
      {blogContent ? <BlogContent nextPost={nextPost} data={blogContent} /> : null}
    </div>
  );
};
